/* eslint-disable */
// WARNING: Do not edit this file

const ebconfig = {
    "integration": "project-Transblue-GP0RcMUgSXLc0j90qn6blQjOvRR7gZeR",
    "version": "2020-11-20"
  }
  
  export default ebconfig;